import type {Maybe} from '@/types'

export function isRateboardEmail(email: Maybe<string>): boolean {
  return !!email?.toLowerCase().endsWith('@rateboard.io')
}
